export { default } from './ShelfPrintList';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfPrintList/index.js